angular.module('unica_track.track_services')

.factory('TrackCreateService', function ($http, getBaseApiURL) {

	var trackCreateService = {};

	trackCreateService.create = function ( trackData) {

		return $http({
			method: 'POST',
			url: getBaseApiURL + '/track/create',
			data: trackData
		}).then(function(result) {

			if ( result ) {
				return result.data.track;
			}

		});
 
	};

	return trackCreateService;
});